// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__39akj","bg":"Badge_bg__3Hcsb","title":"Badge_title__2QOwV"};